export default __webpack_public_path__ + "static/media/troublesomeIcon.31f82b90.svg";